<template>
  <v-container fluid class="mx-0 px-0 py-0 my-0">
    <v-row class="mx-0 px-0 py-0 my-0">
      <v-col class="mx-0 px-0 py-0 my-0" cols="12">
        <v-scale-transition origin="bottom right">
          <web-chat
            v-show="isOpen"
            class="elevation-16"
            :mainColor="mainColor"
            :clientImage="clientImage"
            :poweredBy="poweredBy"
            :showResetButton="showResetButton"
            :title="title"
            :welcomeMessage="welcomeMessage"
            :welcomeTitle="welcomeTitle"
            :buttonTitle="buttonTitle"
            :persistentMenu="persistentMenu"
            :getStarted="getStarted"
            @close="isOpen=!isOpen"
          />
        </v-scale-transition>
        <v-scale-transition origin="bottom right">
          <div
            v-show="!isOpen"
            class="chat-bubble-welcome elevation-5 py-2 px-2"
            :class="{
              mobile: $vuetify.breakpoint.mobile,
              bouncing: !hasOpened
            }"
          >
            {{ bubbleMessage }}
          </div>
        </v-scale-transition>
        <v-btn
          v-show="showButton"
          class="webchat-widget-button"
          :class="{
            mobile: $vuetify.breakpoint.mobile,
            bouncing: !hasOpened
          }"
          bottom
          right
          fixed
          color="#fff"
          fab
          dark
          @click="isOpen=!isOpen"
        >
          <v-fab-transition hide-on-leave>
            <v-icon v-show="isOpen" color="#000">
              mdi-close
            </v-icon>
          </v-fab-transition>
          <v-fab-transition hide-on-leave>
            <v-img
                v-show="!isOpen"
                :src="this.$store.getters.getClientImage"
                aspect-ratio="1"
                contain
                class="rounded-circle"
            />
          </v-fab-transition>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WebChat from '@/components/WebChat'

export default {
  components: {
    WebChat,
  },
  props: {
    clientImage: {
      type: String,
      default: null
    },
    poweredBy: {
      type: Boolean,
      default: false
    },
    showResetButton: {
      type: Boolean,
      default: false
    },
    mainColor: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    welcomeMessage: {
      type: String,
      default: ''
    },
    welcomeTitle: {
      type: String,
      default: ''
    },
    buttonTitle: {
      type: String,
      default: ''
    },
    bubbleMessage: {
      type: String,
      default: ''
    },
    persistentMenu: {
      type: Object,
      default: null
    },
    getStarted: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    isOpen: false,
    hasOpened: false
  }),
  computed: {
    showButton() {
      return !this.$vuetify.breakpoint.mobile ? true : !this.isOpen
    }
  },
  watch: {
    isOpen: function (newValue) {
      if (newValue && !this.hasOpened) {
        this.hasOpened = true
      }
    }
  }
}
</script>

<style>
  .chat-bubble-welcome {
    bottom: 150px;
    position: fixed;
    background: #fff;
    right: 10px;
    border-radius: 10px;
    font-size: 0.9em;
    max-width: 250px;
    white-space: pre-line;
  }

  .chat-bubble-welcome.mobile {
    bottom: 125px;
  }

  .webchat-widget-button {
    bottom: 85px!important;
  }

  .webchat-widget-button.mobile {
    bottom: 60px!important;
  }

  .bouncing {
    animation-name: bounce;
    animation-duration: 0.53s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: 10;
    animation-direction: alternate;
  }

  @keyframes bounce {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      transform: translate3d(0, 10px, 0);
    }
  }
</style>
